<button
  mat-icon-button
  *ngFor="let ratingId of ratingArr; index as i;"
  [color]="starsColor"
  [id]="'star_' + i"
  [matTooltip]="ratingId+1"
  matTooltipPosition="above"
  [ngClass]="{ 'non-clickable': !clickAbleStar }"
  (click)="clickAbleStar && onStarClick(i + 1)">
  <mat-icon>
    {{ rating >= i + 1 ? 'star' : 'star_border' }}
  </mat-icon>
</button>
